import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React from "react";
import PropTypes from "prop-types";
import Status from "components/common_components/Status";

const Comfirmation = ({ category, form, client, visible, onContinue, onBackClick }) => {
    return (
        <div
            className={clsx("layout comfirmation-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <h3>{"Comfirm information"}</h3>
                    <small>
                        <i>Make sure your selection is okay.</i>
                    </small>
                    <div className="details">
                        <Card disabled>
                            <span>{category}</span>
                            <Icon name="rounded-check" color="extra" size="xlg" />
                        </Card>
                        <Card
                            title={
                                <>
                                    {form.code}    {form.isCurrent ? <Status id="active" /> : <Status id="oldVersion" />}
                                </>
                            }
                            disabled
                        >
                            <div>
                                <div className="form-version">
                                    <span>{`Version ${form.version}`} </span>
                                </div>
                            </div>
                            <Icon name="rounded-check" color="extra" size="xlg" />
                        </Card>
                        <Card disabled>
                            <span>
                                {client?.fullName} {client?.enabled ? <Status id="active" /> : <Status id="inactive" />}
                            </span>
                            <Icon name="rounded-check" color="extra" size="xlg" />
                        </Card>
                    </div>
                    <Button primary onClick={onContinue}>
                        <span>Comfirm</span>
                    </Button>
                </>
            )}
        </div>
    );
};

Comfirmation.propTypes = {
    category: PropTypes.string,
    form: PropTypes.shape({
        code: PropTypes.string,
        version: PropTypes.string,
    }),
    client: PropTypes.shape({
        fullName: PropTypes.string,
    }),
    visible: PropTypes.bool,
    onContinue: PropTypes.func,
    onBackClick: PropTypes.func,
};

Comfirmation.defaultProps = {
    category: "",
    form: {
        code: "",
        version: "",
    },
    client: {
        fullName: "",
    },
    visible: false,
    onContinue: () => {},
    onBackClick: () => {},
};

export default Comfirmation;
